// What a tab does when another tab broadcasts a log out (`fp_logout` in
// localStorage): drop this tab's session and go to the login page.
//
// The SSO-only tenant's automatic start is held first, before the session
// cookies go: once they are gone the login page renders, and without the hold
// it would start SSO at once and sign the user back in through their
// identity-provider session, in this tab and so in every tab sharing the
// cookie (utils/ssoAutoStart.ts).

import Cookies from "js-cookie";
import { clearSessionToken } from "@/services/sessionToken";
import { holdSsoAutoStart } from "./ssoAutoStart";

export const LOGOUT_BROADCAST_KEY = "fp_logout";

export const endSessionForLogoutBroadcast = (
  navigateTo: (url: string) => void
): void => {
  holdSsoAutoStart();
  Cookies.remove("stytch_session");
  Cookies.remove("stytch_session_jwt");
  clearSessionToken(); // an embedded frame's session (#15202)
  sessionStorage.removeItem("sessionId");
  navigateTo("/");
};
